<template>
  <MyLink
    name="category"
    :params="{ categorySlug: getCategorySlug() }"
    class="filter-checkbox__compilation"
    @click="scrollTop"
  >
    <BaseCheckbox v-model="checked" :validate="{}" class="filter-checkbox">
      <span class="filter-checkbox__title">
        <slot />
      </span>
    </BaseCheckbox>
  </MyLink>
</template>

<script setup>
import BaseCheckbox from "~/modules/shared/inputs/BaseCheckbox.vue";

const props = defineProps({
  category: { type: Object, required: true },
  currentCategorySlug: { type: String, required: true },
});

const checked = computed({
  get() {
    return props.category?.slug === props.currentCategorySlug;
  },
  set() {},
});

const getCategorySlug = () => {
  return props.category.slug === props.currentCategorySlug
    ? props.category.parent.slug
    : props.category.slug;
};

function scrollTop() {
  window.scrollTo({ top: 0, behavior: "smooth" });
}
</script>
